import { MenuItem, TextField } from '@mui/material';
import { useAdminI18n } from '@/contexts/AdminI18nContext';
import { ADMIN_TIME_ZONES, useAdminTime, type AdminTimeZone } from '@/contexts/AdminTimeContext';

export default function AdminTimeZoneSelect() {
  const { timeZone, setTimeZone } = useAdminTime();
  const { t } = useAdminI18n();

  return (
    <TextField
      select
      size="small"
      label={t('admin.time.label')}
      value={timeZone}
      onChange={(event) => setTimeZone(event.target.value as AdminTimeZone)}
      sx={{
        minWidth: 178,
        '& .MuiInputBase-root': {
          borderRadius: 999,
        },
      }}
    >
      {ADMIN_TIME_ZONES.map((zone) => (
        <MenuItem key={zone.value} value={zone.value}>
          {zone.label} ({zone.detail})
        </MenuItem>
      ))}
    </TextField>
  );
}
